module.exports = __webpack_public_path__ + "img/site_icon.f3265e35.svg";